// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { useTheme } from 'lib/context/ThemeContext';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
// Components
import { AccordionTheme } from './Accordion.theme';
import Headline from 'src/helpers/Headline/Headline';
import AccordionSection from './AccordionSection.helper';
import { RouteData } from '@sitecore-jss/sitecore-jss/layout';
import { ComponentProps } from 'lib/types/component-props';
import { RichTextWrapper } from 'src/helpers/RichTextWrapper';
import Component from 'src/helpers/Component/Component';

export type AccordionProps =
  Feature.EnterpriseWeb.Enterprise.Components.Tabs.Accordion.Accordion & {
    fields: {
      children: AccordionSectionProps[];
    };
  } & ComponentProps;

export type AccordionSectionProps = RouteData &
  Feature.EnterpriseWeb.Enterprise.Components.Tabs.Accordion.AccordionSection;
const Accordion = (props: AccordionProps) => {
  const { themeData } = useTheme(AccordionTheme);

  return (
    <Component dataComponent="tabs/accordion" {...props}>
      <div className="theme-white col-span-12 my-8">
        <Headline {...props} classes={themeData.classes.headline} />
        <RichTextWrapper field={props.fields?.body} classes={themeData.classes.bodyCopy} />
        {props?.fields?.children?.map((accordionSection: AccordionSectionProps, index: number) => {
          return <AccordionSection key={index} {...accordionSection} themeData={themeData} />;
        })}
      </div>
    </Component>
  );
};

export default withDatasourceCheck()<AccordionProps>(Accordion);
